import { render, staticRenderFns } from "./newIndex.vue?vue&type=template&id=0da2796b&scoped=true&"
import script from "./newIndex.vue?vue&type=script&lang=ts&"
export * from "./newIndex.vue?vue&type=script&lang=ts&"
import style0 from "./newIndex.vue?vue&type=style&index=0&id=0da2796b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0da2796b",
  null
  
)

export default component.exports